
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashlane-password-manager",
      function () {
        return require("private-next-pages/dashlane-password-manager.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashlane-password-manager"])
      });
    }
  